module.exports = __webpack_public_path__ + "static/media/icon-refrigeration.e0def6c1.svg";